import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bianji",
  "use": "icon-bianji-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bianji\"><path d=\"M318.09038 695.11c0.03 0.03 0.04 0.06 0.07 0.07 21.02 20.98 55.06 20.95 76.03-0.07l588.61-588.5c21.04-21.05 21.04-55.18 0-76.23-0.06-0.07-0.13-0.13-0.18-0.18-21.05-20.95-55.09-20.87-76.03 0.18l-588.5 588.5c-21.03 21.05-21.03 55.18 0 76.23zM970.12038 431.13h-0.23c-29.63 0-53.65 24.02-53.65 53.65v431.43H107.81038v-808.6l431.4 0.2h0.04c29.69-0.08 53.69-24.23 53.61-53.92v-0.23c0-29.63-24.02-53.65-53.65-53.65H53.54038a53.708 53.708 0 0 0-38.02 15.8A53.326 53.326 0 0 0 0.00038 53.62v916.83a54.272 54.272 0 0 0 15.79 38.01 53.307 53.307 0 0 0 37.82 15.52h916.86a54.272 54.272 0 0 0 38.01-15.79 53.417 53.417 0 0 0 15.52-37.86V484.78c-0.07-29.69-24.19-53.71-53.88-53.65z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bianji.svg
// module id = VIAZ
// module chunks = 16